if (!customElements.get("facet-filters")) {
  class e extends SideDrawer {
    connectedCallback() {
      this.init()
    }
    disconnectedCallback() {
      window.removeEventListener("popstate", this.historyChangeHandler), this
        .breakpointChangeHandler && window.removeEventListener("on:breakpoint-change", this
          .breakpointChangeHandler)
    }
    init() {
      this.filteringEnabled = "true" === this.dataset.filtering, this.sortingEnabled = "true" ===
        this.dataset.sorting, this.form = document.getElementById("facets"), this.results =
        document.getElementById("filter-results"), this.expanded = [], this
        .handleBreakpointChange(), this.addElements(), this.addListeners(), this
        .historyChangeHandler = this.historyChangeHandler || this.handleHistoryChange.bind(this),
        window.addEventListener("popstate", this.historyChangeHandler)
    }
    addElements() {
      this.filteringEnabled && (this.filters = this.querySelector(".facets__filters"), this
          .activeFilters = this.querySelector(".facets__active-filters"), this.activeFiltersList =
          this.querySelector(".active-filters"), this.activeFiltersHeader = this.querySelector(
            ".active-filters-header"), this.footer = this.querySelector(".facets__footer")), this
        .sortingEnabled && (this.mobileSortByOptions = this.querySelectorAll(
          ".js-drawer-sort-by"), this.desktopSortBy = document.querySelector(
            ".products-toolbar__sort"))
    }
    addListeners() {
      this.filteringEnabled && (this.breakpointChangeHandler = this.breakpointChangeHandler ||
          this.handleBreakpointChange.bind(this), this.filters.addEventListener("click", this
            .handleFiltersClick.bind(this)), this.filters.addEventListener("input", debounce(this
            .handleFilterChange.bind(this), 500)), this.activeFilters.addEventListener("click",
            this.handleActiveFiltersClick.bind(this)), window.addEventListener(
            "on:breakpoint-change", this.breakpointChangeHandler)), this.sortingEnabled && this
        .desktopSortBy.addEventListener("change", this.handleFilterChange.bind(this))
    }
    handleBreakpointChange() {
      theme.mediaMatches.lg ? (this.setAttribute("open", ""), this.setAttribute("aria-hidden",
        "false"), this.removeAttribute("aria-modal"), this.removeAttribute("role")) : (this
        .close(), this.setAttribute("role", "dialog"), this.setAttribute("aria-modal", "true"),
        this.setAttribute("aria-hidden", "true"), this.hidden = !1)
    }
    handleFilterChange(e) {
      let t = new FormData(this.form),
        s = new URLSearchParams(t),
        i = [];
      if (this.sortingEnabled) {
        let r = s.get("sort_by");
        "CUSTOM-SELECT" === e.target.tagName && this.mobileSortByOptions.forEach(t => {
          t.checked = t.value === e.detail.selectedValue, r = e.detail.selectedValue
        }), s.set("sort_by", r)
      }
      s.forEach((e, t) => {
        e || i.push(t)
      }), i.forEach(e => {
        s.delete(e)
      }), this.applyFilters(s.toString(), e)
    }
    handleFiltersClick(e) {
      let {
        target: t
      } = e;
      if (t.matches(".js-clear-filter") && (e.preventDefault(), this.applyFilters(new URL(e.target
          .href).searchParams.toString(), e)), t.matches(".js-show-more")) {
        let s = t.closest(".filter");
        t.remove(), s.querySelectorAll("li").forEach(e => {
          e.classList.remove("js-hidden")
        }), this.expanded.includes(s.id) || this.expanded.push(s.id)
      }
    }
    handleActiveFiltersClick(e) {
      "A" === e.target.tagName && (e.preventDefault(), this.applyFilters(new URL(e.target.href)
        .searchParams.toString(), e))
    }
    handleHistoryChange(e) {
      if (null !== e.state) {
        let t = "";
        e.state && e.state.searchParams && ({
          searchParams: t
        } = e.state), this.applyFilters(t, null, !1)
      }
    }
    async applyFilters(t, s, i = !0) {
      try {
        let r = document.querySelector("custom-pagination");
        r && (r.dataset.pauseInfiniteScroll = "true"), this.results.classList.add("is-loading");
        let l = this.querySelector(".js-close-drawer-mob");
        l.ariaDisabled = "true", l.classList.add("is-loading");
        let a = `${window.location.pathname}?${t}`;
        this.form.dataset.filterSectionId && (a +=
            `&section_id=${this.form.dataset.filterSectionId}`), this
          .applyFiltersFetchAbortController && this.applyFiltersFetchAbortController.abort(
            "Request changed"), this.applyFiltersFetchAbortController = new AbortController;
        let n = await fetch(a, {
          method: "GET",
          signal: this.applyFiltersFetchAbortController.signal
        });
        if (n.ok) {
          let h = document.createElement("template");
          h.innerHTML = await n.text(), this.form.querySelectorAll("details-disclosure > details")
            .forEach(e => {
              let t = h.content.getElementById(e.id);
              t && (t.open = e.open)
            }), h.content.querySelectorAll("#facets details-disclosure > details").forEach(e => {
              if (this.expanded.includes(e.id)) {
                let t = e.querySelectorAll(".js-hidden");
                t.forEach(e => {
                  e.classList.remove("js-hidden")
                }), e.querySelector(".filter__more")?.remove()
              }
            }), this.form.innerHTML = h.content.getElementById("facets").innerHTML, l.innerText =
            h.content.querySelector(".js-close-drawer-mob").innerText;
          let o = this.results.querySelector("ul");
          this.currentResultsClass = o ? this.results.querySelector("ul").getAttribute("class") :
            this.currentResultsClass, this.results.innerHTML = h.content.getElementById(
              "filter-results").innerHTML;
          let d = this.results.querySelector("ul");
          if (d && this.currentResultsClass && d.setAttribute("class", this.currentResultsClass),
            this.addElements(), this.addListeners(), "function" == typeof initLazyImages &&
            initLazyImages(), r && r.reload && r.reload(), i && e.updateURL(t), this.results
            .getBoundingClientRect().top < 0) {
            let c = 0;
            document.querySelector('store-header[data-is-sticky="true"]') && (c = Number.parseInt(
              getComputedStyle(this.parentElement).getPropertyValue("--header-height")
              .replace("px", ""), 10) || 0), window.scrollTo({
              top: this.results.getBoundingClientRect().top + window.scrollY - c - 45,
              behavior: "smooth"
            })
          }
          l.classList.remove("is-loading"), l.removeAttribute("aria-disabled"), r && (r.dataset
            .pauseInfiniteScroll = "false"), document.dispatchEvent(new CustomEvent(
            "on:facet-filters:updated"), {
            bubbles: !0
          })
        }
      } catch (u) {
        console.warn(u)
      } finally {
        this.results.classList.remove("is-loading")
      }
    }
    static updateURL(e) {
      window.history.pushState({
        searchParams: e
      }, "", `${window.location.pathname}${e&&"?".concat(e)}`)
    }
  }
  customElements.define("facet-filters", e)
}
